export default "__VITE_ASSET__BbaVwrmC__"